import { Routes, Route } from "react-router-dom";
import CommentsList from "./CommentsList";

export default function CommentsPage() {
    return (
        <Routes>
            <Route path="/" element={<CommentsList />}/>
        </Routes>
    )
}